import { Guid } from "@/Common/Models/Guid";
import { PrivateBill_BilledTo } from "@/Common/Models/UI/Enums";

class TransactionsInboxItem {
    public PrivateBillId: string;
    public TransactionDate: Date;
    public VisitDate: Date;
    public TransactionNumber: string;
    public TransactionProvider: string;
    public SiteName: string;
    public PatientName: string;
    public patientNAM: string;
    public PaymentMethod: string;
    public BilledBy: string;
    public BilledTo: PrivateBill_BilledTo;
    public RecipientName: string;
    public SubTotal: number;
    public GST: number;
    public QST: number;
    public HST: number;
    public GenericTax: number;
    public TotalBill: number;
    public IsInvalid: boolean;
    public SiteId: string;
    public DiscountType: string;
    public SiteGST: number;
    public SiteQST: number;
    public SiteHST: number;
    public SiteGenericTax: number;
    public BillNote: string;
    public PatientId: string;
    public PatientContactId: Guid;
    public Discount_Dollars: number;
    public Discount_Percentage: number;
    public PaymentDate: Date;
}

class SalesInboxItem {
    public SaleDate: Date;
    public SaleNumber: string;
    public SaleProvider: string;
    public PatientName: string;
    public patientNAM: string;
    public PatientContactId: Guid;
    public PaymentMethod: string;
    public BilledBy: string;
    public ServiceID: string;
    public Description: string;
    public Price: number;
    public GST: number;
    public QST: number;
    public HST: number;
    public GenericTax: number;
    public Total: number;
    public IsInvalid: boolean;
    public Quantity: number;
    public GSTSum: number;
    public QSTSum: number;
    public VisitDate: Date;
    public BilledTo: PrivateBill_BilledTo;
    public RecipientName: string;
}

class PayableInboxItem {
    public PrivateBillId: string;

    public CreationDate: Date;
    public VisitDate: Date;

    public Number: string;
    public Provider: string;
    public Site: string;

    public Patient: string;
    public PatientId: string;
    public PatientContactId: Guid;
    public HealthCard: string;

    public BilledBy: string;
    public BilledTo: string;

    public SubTotal: number;
    public Discount: number;

    public GST: number;
    public QST: number;

    public TotalDue: number;

    constructor(field?: Partial<PayableInboxItem>) {
        Object.assign(this, field);
    }
}

class BilledServiceItem {
    public ServiceNumber: string;
    public ServiceName: string;
    public ServiceMultiplicator: number;
    public ServicePrice: number;
    public GST: number;
    public QST: number;
    public HST: number;
    public GenericTax: number;
    public HasGST: boolean;
    public HasQST: boolean;
    public HasHST: boolean;
    public HasGenericTax: boolean;
    public CostCenterId: string;

    public LoadServiceName(NameEn: string, NameFr: string, NameEs: string): string {
        var serviceName = "";

        if (sessionStore.userLanguageCode === "en")
            serviceName = NameEn;
        if (sessionStore.userLanguageCode === "fr")
            serviceName = NameFr;
        if (sessionStore.userLanguageCode.toLowerCase().replace("-", "") === "esmx")
            serviceName = NameEs;

        if (serviceName == null || serviceName == "") {
            if (NameEn != null && NameEn != "")
                serviceName = NameEn;
            if (NameFr != null && NameFr != "")
                serviceName = NameFr;
            if (NameEs != null && NameEs != "")
                serviceName = NameEs;
        }
        return serviceName;
    }
}

export { BilledServiceItem, PayableInboxItem, SalesInboxItem, TransactionsInboxItem };
